export const KYCDetailsInitialValues = {
    account_kyc_name: '',
    business_registartion_type_uuid: '',
    business_name: '',
    account_holder_name: '',
    account_no: '',
    confirm_account_no: '',
    ifsc_swift_code: '',
    account_email_id: '',
    account_phone_number: '',
    address_1: '',
    address_2: '',
    country_id: '',
    province_id: '',
    city: '',
    pin_zip: '',
    account_kyc_document_type_uuid: '',
  }